export const templateTypeValues = {
    ALL_PROMOTION: '',
    SHARE_REFERRAL: 'SHARE_REFERRAL',
    MARKETING: 'MARKETING',
    REVIEW: 'REVIEW',
    TICKET: 'TICKET',
    APPOINTMENT: 'APPOINTMENT',
    NEW_CUSTOMER: 'NEW_CUSTOMER',
};

export const templateTypeLabels = {
  ALL_PROMOTION: 'All Promotion',
  SHARE_REFERRAL: 'Share Referral',
  MARKETING: 'Marketing',
  REVIEW: 'Review',
  TICKET: 'Ticket',
  APPOINTMENT: 'Appointment',
  NEW_CUSTOMER: 'New Customer',
};

export const templateTypeOptions = [
  { value: templateTypeValues.ALL_PROMOTION, label: templateTypeLabels.ALL_PROMOTION },
  { value: templateTypeValues.SHARE_REFERRAL, label: templateTypeLabels.SHARE_REFERRAL },
  { value: templateTypeValues.MARKETING, label: templateTypeLabels.MARKETING },
  { value: templateTypeValues.REVIEW, label: templateTypeLabels.REVIEW },
  { value: templateTypeValues.TICKET, label: templateTypeLabels.TICKET },
  { value: templateTypeValues.APPOINTMENT, label: templateTypeLabels.APPOINTMENT },
  { value: templateTypeValues.NEW_CUSTOMER, label: templateTypeLabels.NEW_CUSTOMER },
];